import papa from 'papaparse'
import React from 'react'
import Body from './Body'
import Footer from './Footer'

const useGetInternalMultiplyCityBasicTrackingPopup = ({
  onConfirm,
  onClose,
  isCanBeConfirmed,
  setCriticalError,
  setFile,
  error,
  setCodesTable,
  setWarning,
  citiesArray: campaignCitiesArray,
  isCodesUploading,
}) => {
  const title = 'Upload codes file'

  const onFileUpload = (entryFiles, ...rest) => {
    setCriticalError(null)
    setWarning(null)
    if (entryFiles.length) {
      setFile(entryFiles[0])
      papa.parse(entryFiles[0], {
        complete: function(results, file) {
          const data = results.data
          const codesArray = []
          const citiesArray = []

          data.forEach((dataItem, rowIndex) => {
            if (rowIndex === 0) {
              return
            }
            const code = dataItem[0]
            const city = dataItem[1]
            if (code || city) {
              codesArray.push(code || '')
              citiesArray.push(city || '')
            }
          })

          //Validate that required headers exist in file in A1:C1:
          if (
            data[0][0].trim().toUpperCase() !== 'FLYER CODE' ||
            data[0][1].trim().toUpperCase() !== 'CITY'
          ) {
            setCriticalError(
              'Header value missing or incorrect. Please follow the instructions in the template and try again.',
            )
            return
          }

          //If file does not contain any required values:
          if (codesArray.includes('') || citiesArray.includes('')) {
            setCriticalError(
              'No codes or links found in file. Please review and try again.',
            )
            return
          }

          let shouldStop = false
          citiesArray.forEach(city => {
            if (
              !campaignCitiesArray.find(
                currentCity => currentCity.name === city,
              )
            ) {
              setCriticalError(
                `${city} is not a valid city for this campaign. Please review the file and try again.`,
              )
              shouldStop = true
            }
          })

          if (shouldStop) {
            return
          }

          if (codesArray.find(code => code.length > 12)) {
            setCriticalError('Codes can not be longer than 12 characters.')
            return
          }
          //If client uploads csv file with not relevant city name in city column:
          //TODO

          //If client uploads csv file that contains duplicate codes:
          const uniqueCodes = Array.from(new Set(codesArray))
          if (codesArray.length !== uniqueCodes.length) {
            setCriticalError('Caution: file contains duplicate codes.')
            return
          }

          const formattedData = []
          data.forEach((row, index) => {
            if (index !== 0 && row[0] && row[1]) {
              formattedData.push({
                code: row[0],
                cityId: campaignCitiesArray.find(
                  currentCity => currentCity.name === row[1],
                ).id,
              })
            }
          })
          setCodesTable(formattedData)
        },
      })
    }
  }

  return {
    body: (
      <Body
        error={error}
        onFileUpload={onFileUpload}
        setError={setCriticalError}
        setFile={setFile}
      />
    ),
    footer: (
      <Footer
        onConfirm={onConfirm}
        onClose={onClose}
        isCanBeConfirmed={isCanBeConfirmed}
        isCodesUploading={isCodesUploading}
      />
    ),
    title: title,
  }
}

export default useGetInternalMultiplyCityBasicTrackingPopup
